import { triggerAuthChange } from '../../common/utils/broadcastChannel'
import storage from '../../common/utils/storage'
import { isPartnerDomain } from '../currentDomain'

export function signOut(
    { showNotificationMessage }: { showNotificationMessage: boolean } | undefined = { showNotificationMessage: true }
): void {
    storage.removeItem('token')
    storage.removeItem('user')
    if (isPartnerDomain) storage.removeItem('iw_state')

    showNotificationMessage && storage.setItem('notification', { text: 'lblSignedOutMessage', type: 'notice' })

    triggerAuthChange()
}
